export default __webpack_public_path__ + "static/media/clothing.ab09967d.png";